export const companyPartnerIds = {
  KINSIDE: 1,
  OUTSCHOOL: 2,
  CARILOOP: 3,
  ACTIVITY_HERO: 8,
};

export const companyLandingPageAllowedHosts = [
  'www.urbansitter.com',
  'benefits.urbansitter.com',
];
